import React from "react";
import UnitKerjaColumns from "../constants/TableColumns";
import UnitKerjaSearchCategories from "../constants/SearchCategories";
import PengaturanListLayout from "../../../../Layout/Components/PengaturanListLayout";

const UnitKerjaList = ({ items, resetState, pending }) => {
  return (
    <PengaturanListLayout
      items={items}
      itemColumns={UnitKerjaColumns(resetState)}
      searchCategories={UnitKerjaSearchCategories}
      pending={pending}
    />
  );
};
export default UnitKerjaList;
